module.exports = {
  apiUrl: process.env.VUE_APP_BACKEND
};
